const maps = require("../maps");

/**
 * Applies style to google.maps.Data.
 * @private
 * @class
 * @memberOf woosmap.style
 */
class DataStyler {
    /**
     * @param {woosmap.style.Styler} styler
     * @constructor
     * @since 1.1.0
     */
    constructor(styler) {
        if (!styler) {
            throw new Error("DataStyler: styler parameter is mandatory.");
        }
        /**
         *
         * @type {woosmap.style.Styler}
         * @private
         */
        this._styler = styler;
    }

    /**
     * Styles the data layer using Styles rules given at construction.
     * @param {google.maps.Data} data
     */
    style(data) {
        if (this._styler) {
            data.setStyle((store) => {
                return {
                    icon: this._styler.getMarkerStyleForStore(store, { selected: false }),
                };
            });
        }
    }

    /**
     * Override the style to use numbered icons for the stores array parameter.
     * @param {google.maps.Data} data
     * @param stores the stores array to number.
     */
    styleNumbered(data, stores) {
        if (this._styler) {
            data.setStyle((store) => {
                const storeIndex = this._findStoreIndex(store.getProperty("store_id"), stores);

                return {
                    icon: this._styler.getMarkerStyleForStore(store, { number: 1 + storeIndex }),
                };
            });
        }
    }

    /**
     * Overrides the current style with selectedStyle for the selectedStore
     * @param {google.maps.Data}data
     * @param selectedStore the store to select.
     */
    selectStore(data, selectedStore) {
        data.revertStyle();

        if (this._styler) {
            if (selectedStore) {
                const storeFeature = data.getFeatureById(selectedStore.properties.store_id);
                if (storeFeature) {
                    data.overrideStyle(storeFeature, {
                        icon: this._styler.getMarkerStyleForStore(storeFeature, { selected: true }),
                        zIndex: google.maps.Marker.MAX_ZINDEX,
                    });
                }
            }
        }
    }

    /**
     * Clear the style of the data layer.
     * @param {google.maps.Data} data
     */
    clear(data) {
        data.setStyle(null);
    }

    /**
     * Finds the index in the stores array of the store identified by `storeId`
     * @param {String}storeId the storeId to find.
     * @param {Array}stores the stores array to search.
     * @returns {Number}
     * @private
     */
    _findStoreIndex(storeId, stores) {
        for (let i = 0; i < stores.length; i++) {
            if (stores[i].properties.store_id === storeId) {
                return i;
            }
        }
    }
}

module.exports = DataStyler;
